import {
  RawBusinessListResponse,
  RawBusinessListingsResponse,
} from "../../../interfaces/BusinessObject";

export const dummyMyBusinesses: RawBusinessListResponse = {
  contents: [
    {
      businessId: "biz-001",
      creatorId: "owner-user-001",
      creatorName: "Rajan Kumar",
      ownerId: "owner-user-001",
      ownerName: "Rajan Kumar",
      name: "Coffee Corner",
      listingType: "menu",
      listingTypeLabel: "Menu Item",
      phone: "9876543210",
      description: "Fresh brews and snacks all day. Stop by for your daily cup.",
      logoUrl: undefined,
      collaborators: [{ collaboratorPhone: "9123456789" }],
      role: "owner",
      createdAt: "2026-04-01T10:00:00Z",
    },
    {
      businessId: "biz-002",
      creatorId: "owner-user-002",
      creatorName: "Priya Sharma",
      ownerId: "owner-user-002",
      ownerName: "Priya Sharma",
      name: "My Rentals Co",
      listingType: "rental",
      listingTypeLabel: "Rental",
      phone: "9000011111",
      description: "Quality rentals at affordable prices.",
      logoUrl: undefined,
      collaborators: [],
      role: "collaborator",
      createdAt: "2026-03-15T08:30:00Z",
    },
  ],
  totalCount: 2,
};

// NOTE: Product objects inside business listings remain snake_case because
// they flow through convertRawProduct, which is part of the (still snake_case)
// product API contract. Only the outer business envelope is camelCase.
export const dummyBusinessListings: Record<string, RawBusinessListingsResponse> = {
  "biz-001": {
    products: [
      {
        product_id: "prod-b001-1",
        title: "Espresso Blend",
        selling_price: 250,
        description: "Rich espresso shot, freshly brewed.",
        listing_type: "Menu Item",
        seller_id: "owner-user-001",
        seller_name: "Rajan Kumar",
        seller_verified: true,
        business_id: "biz-001",
        business_name: "Coffee Corner",
        media: { image_url_list: [] },
        status: "active",
        created_time: "2026-04-10T09:00:00Z",
      },
      {
        product_id: "prod-b001-2",
        title: "Cold Brew",
        selling_price: 180,
        description: "Slow-steeped cold brew, served chilled.",
        listing_type: "Menu Item",
        seller_id: "owner-user-001",
        seller_name: "Rajan Kumar",
        seller_verified: true,
        business_id: "biz-001",
        business_name: "Coffee Corner",
        media: { image_url_list: [] },
        status: "active",
        created_time: "2026-04-11T09:00:00Z",
      },
      {
        product_id: "prod-b001-3",
        title: "Chocolate Muffin",
        selling_price: 120,
        description: "Freshly baked every morning.",
        listing_type: "Menu Item",
        seller_id: "owner-user-001",
        seller_name: "Rajan Kumar",
        seller_verified: true,
        business_id: "biz-001",
        business_name: "Coffee Corner",
        media: { image_url_list: [] },
        status: "active",
        created_time: "2026-04-12T09:00:00Z",
      },
    ],
    totalCount: 3,
  },
  "biz-002": {
    products: [
      {
        product_id: "prod-b002-1",
        title: "DSLR Camera",
        selling_price: 800,
        description: "Canon EOS 200D, perfect for events.",
        listing_type: "Rental",
        seller_id: "owner-user-002",
        seller_name: "Priya Sharma",
        seller_verified: false,
        business_id: "biz-002",
        business_name: "My Rentals Co",
        media: { image_url_list: [] },
        status: "active",
        created_time: "2026-03-20T10:00:00Z",
      },
      {
        product_id: "prod-b002-2",
        title: "Projector",
        selling_price: 1200,
        description: "Full HD projector, includes screen.",
        listing_type: "Rental",
        seller_id: "owner-user-002",
        seller_name: "Priya Sharma",
        seller_verified: false,
        business_id: "biz-002",
        business_name: "My Rentals Co",
        media: { image_url_list: [] },
        status: "active",
        created_time: "2026-03-22T10:00:00Z",
      },
    ],
    totalCount: 2,
  },
};

// Mock generic response based on the real API structure for user businesses
const mockGenericBusiness = {
  businessId: "c691c0ab-694e-4d9f-a75a-a31934acce18",
  name: "BusinessTest",
  creatorId: "737fb03e-79c1-4cea-98c3-3c5937498922",
  creatorName: "City nest",
  ownerName: "City nest",
  ownerId: "737fb03e-79c1-4cea-98c3-3c5937498922",
  email: null,
  phone: "7989291279",
  description: "Test description for this business.",
  collaborators: [{ collaboratorPhone: "9611379962" }],
  longitude: null,
  latitude: null,
  averageRating: null,
  logoUrl: null,
  listingType: "menu",
  listingTypeLabel: "Menu",
  website: null,
  address: null,
  createdAt: null,
  active: false,
};

export const dummyUserBusinesses: Record<string, any> = {
  "owner-user-001": {
    contents: [dummyMyBusinesses.contents[0]],
    totalCount: 1,
  },
  "generic_mock": {
    contents: [mockGenericBusiness],
    totalCount: 1,
  }
};

// Public (customer) view of businesses — no role field
export const dummyPublicBusinesses: Record<string, any> = {
  "biz-001": {
    ...dummyMyBusinesses.contents[0],
    role: undefined,
  },
  "biz-002": {
    ...dummyMyBusinesses.contents[1],
    role: undefined,
  },
};

